import { byId } from "./domUtils";
import type { Root } from "./prototypeTypes";

interface ArticleMetaResponse {
  topicTitle?: string;
  chapterLabel?: string;
	chapter?: {
    index?: number;
    duration?: string;
  };
}

export function paintArticleMeta(root: Root, response: ArticleMetaResponse, chapterTotal?: number) {
	// The "Chapter" label is now in a <b> tag (same pattern as Duration),
	// so we only paint the chapter number/label text into the data-bind span.
	// With a total available the metric matches the SSR hero ("7 of 8");
	// otherwise fall back to the bare index until the topic store fills in.
	const index = response.chapter?.index;
	let label: string | undefined;
	if (typeof index === 'number' && index > 0 && typeof chapterTotal === 'number' && chapterTotal >= index) {
		label = `${index} of ${chapterTotal}`;
	} else {
		const rawLabel = response.chapterLabel ?? (index ? `Chapter ${index}` : undefined);
		label = rawLabel ? rawLabel.replace(/^Chapter\s+/i, '') : undefined;
	}
	paintBoundText(byId(root, "article-meta-chapter"), label);
	paintBoundText(byId(root, 'article-meta-duration'), response.chapter?.duration);
}

function paintBoundText(node: HTMLElement | null, value: string | undefined | null) {
  if (!node) return;
  const text = value?.trim() ?? "";
	const valueNode = node.matches('[data-bind]') ? node : node.querySelector<HTMLElement>("[data-bind]");
	if (valueNode) valueNode.textContent = text;
	// Remove the loading skeleton class that primeArticleShell added so the
	// real metric text (or hidden state) takes over.
	node.classList.remove('chapter-metric--loading');
	node.hidden = text.length === 0;
}
